/* eslint-disable */
import axios from 'axios'

const getUploadSign = (name, type = 1) => {
  // 文件类型，1：图片，2：语音，3、视频，4、文档
  return axios({
    method: 'get',
    url: '/api/applet/cos/sign/get',
    params: {
      file_name: name,
      file_type: type
    }
  })
}

export async function uploadFile (file, fileType = 1) {
  const name = file.name || file.size
  const fileName = Date.now() + '-' + name
  const type = ['image', 'audio', 'video'][fileType - 1]
  const url = `https://tj.file.myqcloud.com/files/v2/1252412068/overseas/user/${type}/${fileName}`
  const { signature } = await getUploadSign(fileName, fileType)
  const headers = {
    Authorization: signature
  }
  const formdata = new FormData()
  formdata.append('op', 'upload')
  formdata.append('filecontent', file)
  const { data } = await axios.post(url, formdata, {
    headers
  })
  return data.resource_path.split('overseas')[1]
}

export const searchCities = keyword => axios.get('/api/applet/city/search', { params: { keyword } })

export const getCityInfo = city_id => axios.get('/api/applet/city/info/get', { params: { city_id } })



// WEBPACK FOOTER //
// ./src/api/common.js